// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json = require("../Json.bs.js");
var Curry = require("bs-platform/lib/js/curry.js");
var JwtDecode = require("../bindings/JwtDecode.bs.js");
var TypeUtils = require("./TypeUtils.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Result = require("relude/src/Relude_Result.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");

var include = TypeUtils.MakeOpaqueStringType({});

var fromString = include.fromString;

var toString = include.toString;

var encode = include.encode;

function toAuthHeader(param) {
  return Relude_Globals.$great$great(toString, (function (param) {
                return "Bearer " + param;
              }), param);
}

function fromString$1(maybeJwt) {
  return Curry._2(Relude_Option.flatMap, (function (param) {
                return Relude_Globals.$great$great((function (param) {
                              return Relude_Globals.$$const(maybeJwt, param);
                            }), fromString, param);
              }), JwtDecode.decode(maybeJwt));
}

var decode = Curry._1(Json.Decode.variantFromString, fromString$1);

function parse(param) {
  return Relude_Globals.$great$great((function (param) {
                return Relude_Globals.$great$great(decode, Relude_Result.getOk, param);
              }), Relude_Option.getOrThrow, param);
}

var GraphQL_API = {
  parse: parse,
  serialize: encode
};

var compare = include.compare;

var eq = include.eq;

var Ord = include.Ord;

var $$Set = include.$$Set;

var $$Map = include.$$Map;

exports.toString = toString;
exports.encode = encode;
exports.compare = compare;
exports.eq = eq;
exports.Ord = Ord;
exports.$$Set = $$Set;
exports.$$Map = $$Map;
exports.toAuthHeader = toAuthHeader;
exports.fromString = fromString$1;
exports.decode = decode;
exports.GraphQL_API = GraphQL_API;
/* include Not a pure module */
